/* ==========================================================================
   Dynoforce animaties
   Scroll-reveal: elementen met .rv faden omhoog zodra ze in beeld komen.
   Bij prefers-reduced-motion springt alles direct naar de eindstand en komt
   er geen observer aan te pas.
   ========================================================================== */

(function () {
  'use strict';

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = document.querySelectorAll('.rv');
  if (!items.length) return;

  if (reduced || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('in'); });
    return;
  }

  function toon(entries, observer) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('in');
      observer.unobserve(e.target);
    });
  }

  var io = new IntersectionObserver(toon, { threshold: 0.12 });

  /* Een blok dat hoger is dan het scherm haalt de 12% soms nooit: de algemene
     voorwaarden (een tekstblok van ~16.000 px) bleven daardoor onzichtbaar
     (7-10-2026). Zulke blokken krijgen een eigen observer die afgaat zodra de
     bovenkant 12% boven de onderrand van het scherm komt. */
  var ioHoog = new IntersectionObserver(toon, { threshold: 0, rootMargin: '0px 0px -12% 0px' });

  function volg(el) {
    (el.offsetHeight > window.innerHeight ? ioHoog : io).observe(el);
  }

  items.forEach(volg);

  /* Secties die de theme editor opnieuw inlaadt ook meenemen. */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.rv').forEach(function (el) {
      if (reduced) { el.classList.add('in'); } else { volg(el); }
    });
  });
})();
